import React, {useCallback, useEffect, useMemo, useState} from "react";
import { useSearchParams } from "react-router-dom";
import { Pagination } from "antd";
import useFetchSearch from "../../hooks/useFetchSearch";
import NewsCard from "../../components/_shared/news-card/NewsCard";
import DataNotFound from "../../components/_shared/data-not-found/DataNotFound";
import styles from "./SearchResults.module.scss";
import {useTranslation} from "react-i18next";


const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("s") || "";

  const { i18n } = useTranslation();
  const language = i18n.language;
  console.log("language:", i18n.language);

  const [pageSize, setPageSize] = useState(10);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [query]);

  const { data, loading, error } = useFetchSearch(
      query,
      language,
      currentPage - 1,
      pageSize
  );

  const paginatedNews = useMemo(() => data?.content || [], [data]);

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);


  const handlePageSizeChange = useCallback((current: number, size: number) => {
    setPageSize(size);
    setCurrentPage(1);
  }, []);

  return (
      <div className={styles.SearchContainer}>
        <h2 style={{ marginTop: "4rem" }}>Search Results for "{query}"</h2>

        {loading && <p>Loading...</p>}
        {error && <p>Error: {error.message}</p>}
        {!loading && !error && data?.content.length === 0 && <DataNotFound loading={loading} />}

        <div className={styles.NewsGrid}>
          {paginatedNews.map((post: any) => (
              <NewsCard key={post.id} {...post} />
          ))}
        </div>

        {(data?.totalElements ?? 0) > pageSize && (
            <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={data?.totalElements}
                onChange={handlePageChange}
                onShowSizeChange={handlePageSizeChange}
                showSizeChanger
                className={styles.Pagination}
            />
        )}
      </div>
  );
};

export default SearchResults;
